import { twMerge } from '@/lib/classname/twMerge'
import { cva } from 'class-variance-authority'
import type { ReactNode } from 'react'
import type { LoyaltyCardTagSize } from '../schemas/LoyaltyCardTag'
import type { LoyaltyColorType } from '../schemas/LoyaltyColor'

type LoyaltyCardTagProps = {
  tagLabel: ReactNode
  color?: LoyaltyColorType
  size?: LoyaltyCardTagSize
  className?: string
}

const LoyaltyCardTagCva = cva('', {
  variants: {
    color: {
      primary: 'text-loyalty-primary',
      secondary: 'text-loyalty-secondary',
    } satisfies Record<LoyaltyColorType, string>,
    size: {
      md: 'text-md',
      lg: 'text-lg',
      xl: 'text-xl',
      '3xl': 'text-3xl',
    },
  },
  defaultVariants: {
    color: 'primary',
    size: '3xl',
  },
})

export function LoyaltyCardTag({ tagLabel, color, size, className }: LoyaltyCardTagProps) {
  if (!tagLabel) return

  return (
    <div
      data-testid="loyalty/cardTag"
      className={twMerge(
        'mb-0.5 -rotate-4 bg-white px-1 font-semibold uppercase',
        className,
        LoyaltyCardTagCva({ color, size }),
      )}
    >
      {tagLabel}
    </div>
  )
}
